import {Frontend} from "./frontend";

(function () {
    XonBoard.Users = {
        list: {

            selectors: {
                users_table: $('#users-table'),
                count_label: $('#count-label'),
            },

            init: function () {
                let self = this;
                let table = this.selectors.users_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.users_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        }
                    },
                    columns: [
                        {data: 'name', name: 'users.name'},
                        {data: 'email', name: 'users.email'},
                        {data: 'roles', name: 'roles', searchable: false, sortable: false},
                        {data: 'sites', name: 'sites', searchable: false, sortable: false},
                        // Shows the badge; searched by the Status select (data-column="4") via filterColumn('status')
                        {data: 'status_badge', name: 'status', sortable: false},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false},
                    ],
                    order: [[0, "desc"]],
                    // Start filtered on active users, matching the Status select's default (column 4)
                    searchCols: [null, null, null, null, {search: 'active'}, null],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
